import { Observable } from 'rxjs'

import { PmcPage } from '@/api/model/base'

import { BankCardAPIConstant } from '../constant/bankcard'
import { BaseService } from './base-service'

export class BankCardService extends BaseService {
    protected bankCardConstant: BankCardAPIConstant
    constructor() {
        super()
        this.bankCardConstant = new BankCardAPIConstant()
    }

    bankCardList(data = {}): Observable<PmcPage<any>> {
        return this.requestPmc(this.bankCardConstant.BankCardList(data))
    }

    addBankCard(data = {}): Observable<number> {
        return this.requestPmc(this.bankCardConstant.AddBankCard(data))
    }

    updateBankCard(data = {}): Observable<number> {
        return this.requestPmc(this.bankCardConstant.UpdateBankCard(data))
    }

    batchEnable(data = {}): Observable<number> {
        return this.requestPmc(this.bankCardConstant.BatchEnable(data))
    }

    batchProhibit(data = {}): Observable<number> {
        return this.requestPmc(this.bankCardConstant.BatchProhibit(data))
    }
}
